export default "__VITE_ASSET__qEZ8778q__"